import store from "../store";
export const BRAND_FALLBACK = 'GuestPro Revenue Booster'; // initial/placeholder
const MAX_TITLE_LENGTH = 70;

export function normalizeTitle(raw) {
  if (!raw) return BRAND_FALLBACK;
  const s = String(raw).trim();
  return s.length > MAX_TITLE_LENGTH ? s.slice(0, MAX_TITLE_LENGTH - 1) + '…' : s;
}

// Pure DOM setter
export function setTitle(title) {
  if (!title) return;
  document.title = normalizeTitle(title);
}

// Mutate current route meta so other parts (afterEach) can read resolved title
export function setRouteResolvedTitle(router, title) {
  if (!router || !router.currentRoute) return;
  if (!router.currentRoute.meta) router.currentRoute.meta = {};
  router.currentRoute.meta.title = normalizeTitle(title);
}

// Guard to avoid double-tracking
let _lastTracked = { path: null, title: null };
export function shouldTrack(path, title) {
  const t = normalizeTitle(title || document.title || BRAND_FALLBACK);
  if (_lastTracked.path === path && _lastTracked.title === t) return false;
  _lastTracked = { path, title: t };
  return true;
}

// Wrapper used by components after they fetched data
// trackFn optional: injected analytics caller
export function applyResolvedTitle({ router, title = null, useTemplate = true, trackFn = null }) {
  const merchantName = store.getters.getMerchant ? store.getters.getMerchant.name : "";
  let finalTitle = title ? title : merchantName ? merchantName : BRAND_FALLBACK;
  
  if(title && useTemplate){
    finalTitle = merchantName ? `${finalTitle} | ${merchantName}` : finalTitle;
  }
  
  const final = normalizeTitle(finalTitle);
  setTitle(final);
  setRouteResolvedTitle(router, final);
  if (typeof trackFn === 'function') {
    try {
      trackFn({ pagePath: router && router.currentRoute ? router.currentRoute.fullPath : window.location.pathname, pageTitle: final });
    } catch (e) {
      // swallow analytics errors
      console.warn('trackFn failed', e);
    }
  }
  return final;
}



// WEBPACK FOOTER //
// ./src/utils/titleService.js